import React, { useRef, useState } from "react";
import {
  Typography,
  Container,
  Grid,
  Paper,
  Button,
  Popper,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { CorreosButton } from "../../CorreosButton/CorreosButton";
import { CommonStyles } from "../../../commons/CommonStyles";
import { EnterpriseTeamStyles } from "../EnterpriseTeamStyles";
import { DeteleEnterpriseDataRemoveUserFromEnterprise } from "../../../services/EnterpriseDataCallsService";
import {
  checkIsNullUndefined,
  getErrorMessage,
  useOutsideAlerter,
} from "../../../commons/Utils";
import { AiOutlineUsergroupDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export function DialogDeleteUser(props) {
  const { finishOperation, idEnterprise, user, getInfo } = props;
  const commonClasses = CommonStyles();
  const classes = EnterpriseTeamStyles();
  const wrapperRef = useRef(null);
  const { t, i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDelete, setOpenDelete] = useState(null);

  const handleCancel = () => {
    setAnchorEl(null);
    setOpenDelete(false);
  };

  const handleConfirm = () => {
    DeteleEnterpriseDataRemoveUserFromEnterprise(
      idEnterprise,
      user.userOid
    ).then((response) => {
      if (response && !response.Status) {
        let auxUser = !checkIsNullUndefined(user.userEmail)
          ? user.userEmail
          : !checkIsNullUndefined(user.userPhone)
          ? user.userPhone
          : !checkIsNullUndefined(user.userName)
          ? user.userName
          : "";
        getInfo();
        finishOperation(
          "success",
          t("teamPageDeleteUserFromEnterpriseSucess").replace("{user}", auxUser)
        );
      } else {
        finishOperation("error", getErrorMessage(response, t));
      }
      setOpenDelete(false);
    });
  };

  const handleDelete = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenDelete(true);
  };

  useOutsideAlerter(wrapperRef, handleCancel);

  return (
    <Grid>
      <Tooltip title={t("teamPageDeleteUserFromEnterpriseTooltip")}>
        <IconButton
          className={classes.iconButton}
          onClick={(event) => handleDelete(event)}
        >
          <AiOutlineUsergroupDelete className={commonClasses.iconActionStyle} />
        </IconButton>
      </Tooltip>
      <Popper
        open={openDelete}
        anchorEl={anchorEl}
        placement={"top"}
        style={{ zIndex: 100 }}
        ref={wrapperRef}
      >
        <Paper>
          <Container>
            <Grid container style={{ paddingTop: "1em", paddingBottom: "1em" }}>
              <Grid item xs={12}>
                <Typography className={commonClasses.popperContentText}>
                  {t("teamPageDeleteUserFromEnterpriseText")}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  size="small"
                  onClick={() => handleCancel()}
                  className={commonClasses.leftButton}
                >
                  {t("no")}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <CorreosButton
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => handleConfirm()}
                  className={commonClasses.rightButton}
                >
                  {t("yes")}
                </CorreosButton>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      </Popper>
    </Grid>
  );
}
